import { getCurrencySymbol, isDefaultCurrency } from "helpers/formatters/numbers"

const TRAILING_DOLLAR_SUFFIX = /\s*\(\$\)$/

export function buildCurrencyScaleUnit(currencyScale: string, currency?: string | null): string {
  return isDefaultCurrency(currency)
    ? `($${currencyScale})`
    : `(${getCurrencySymbol(currency)} ${currencyScale})`
}

export function buildScaledCurrencyLabel(label: string, currencyScale: string | null, currency?: string | null): string {
  if (!currencyScale) return label

  const scaleSuffix = buildCurrencyScaleUnit(currencyScale, currency)
  return TRAILING_DOLLAR_SUFFIX.test(label)
    ? label.replace(TRAILING_DOLLAR_SUFFIX, ` ${scaleSuffix}`)
    : `${label} ${scaleSuffix}`
}
